export const transformUser = (data) =>
  data?.map((item) => ({
    id: item?.uuid,
    role_id: item?.role_uuid,
    biller_id: item?.biller_uuid,
    first_name: item?.first_name,
    last_name: item?.last_name,
    email: item?.email_address,
    role: item?.role,
    biller_name: item?.biller,
    status: item?.status,
    last_login: item?.last_login,
  }));

export const transformBillerOptions = (data) =>
  data?.map((item) => ({
    label: item?.name,
    value: item?.uuid,
  }));

export const transformRoleOptions = (data) =>
  data
    ?.filter((item) => item?.code === 'organization' || item?.code === 'biller')
    .map((role) => ({
      label: role?.name,
      value: role?.uuid,
    }));

export const transformSelectedUser = (data) => ({
  id: data?.uuid,
  role_id: data?.role_uuid,
  biller_id: data?.biller_uuid,
  first_name: data?.first_name,
  last_name: data?.last_name,
  email: data?.email_address,
  role: data?.role,
  biller_name: data?.biller,
  is_mfa_enabled: data?.is_mfa_enabled,
  status: data?.status,
});
